module.exports = __webpack_public_path__ + "static/img/nowDataBg.2b32a7a3.png";